<template>
    <div ref="modaldes" class="modal" tabindex="-1" role="dialog" id="modal-ncobradorprogins">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <p class="text-center mb-1 mt-4">
                        <b>Se asignará un responsable de cobranza a los estudiantes del programa: </b>
                    </p>
                    <p class="mb-0 mt-0 text-center">{{ prog.nombre_compuesto }}</p>
                    <p class="mb-0 mt-0 text-center">{{ prog.inscripciones.length }} participantes.</p>

                    <div>
                        <small>{{ input.seleccionados.length }} estudiantes seleccionados.</small>

                        <div class="row">
                            <div class="col-sm-6">
                                <table class="table table-condensed">
                                    <tbody>
                                        <tr v-for="(e, ind) in inscripciones1" :key="ind">
                                            <td><v-checkbox class="ma-0 pa-0" v-model="input.seleccionados" :value="e.id" dense hide-details></v-checkbox></td>
                                            <td>{{ ind + 1 }}.- {{ e.text }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-sm-6">
                                <table class="table table-condensed">
                                    <tbody>
                                        <tr v-for="(e, ind) in inscripciones2" :key="ind">
                                            <td><v-checkbox class="ma-0 pa-0" v-model="input.seleccionados" :value="e.id" dense hide-details></v-checkbox></td>
                                            <td>{{ ind + 1 + tamano }}.- {{ e.text }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <small>{{ input.seleccionados.length }} estudiantes seleccionados.</small>
                    </div>

                    <p class="mb-0 mt-5"><span class="text-danger">*</span> Seleccione al responsable para la cobranza:</p>
                    <div>
                        <v-combobox v-model="input.responsable" :items="responsables" label="Responsable de cobranza" :loading="loadingusuarios" :disabled="loading" hide-details outlined dense></v-combobox>
                    </div>

                    <XFechas ref="xfechas" />

                    <p class="text-center text-danger">
                        <b>{{ msg }}</b>
                    </p>
                    <div class="text-center">
                        <div style="display: inline-block;" v-show="loading" class="loader"></div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button @click="validar()" :disabled="loading || exitoso" type="button" class="btn btn-azul white--text">Asignar seleccionados</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import XFechas from "@/components/AAsignarCobradorFechas.vue";
export default {
    data() {
        return {
            msg: "",
            loading: false,
            exitoso: false,
            loadingusuarios: false,
            responsables: [],
            tamano: 0,
            input: {
                responsable: null,
                seleccionados: [],
            },
            prog: { nombre_compuesto: null, inscripciones: [] },
            inscripciones1: [],
            inscripciones2: [],
        };
    },
    watch: {},
    components: { XFechas },
    methods: {
        open(prog, inscritos) {
            window.console.log("asignar cobrador progins:", prog, inscritos);
            this.prog = prog;
            this.exitoso = false;
            this.input.seleccionados = [];
            this.msg = "";
            this.$refs.xfechas.load();
            let ins1 = [];
            let ins2 = [];
            const vue = this;
            this.tamano = parseInt(inscritos.length / 2);
            inscritos.forEach((e, i) => {
                if (i < vue.tamano) {
                    ins1.push({ id: e.id + "", text: e.estudiante.pri_apellido + " " + e.estudiante.seg_apellido + " " + e.estudiante.nombres });
                } else {
                    ins2.push({ id: e.id + "", text: e.estudiante.pri_apellido + " " + e.estudiante.seg_apellido + " " + e.estudiante.nombres });
                }
            });
            this.inscripciones1 = ins1;
            this.inscripciones2 = ins2;
            window.$("#modal-ncobradorprogins").modal("show");
        },
    },
    mounted() {},
};
</script>
